export const removeToken = async () => {
	try {
		await fetch('/api/logout', { method: 'POST' });
	} catch {}
};
